import { useParams } from "react-router-dom"
import { ConversationsList, If, ImagePreviewPanel } from ".."
import ConversationsThread from "../conversations-thread"
import ConversationLeadDetailsPanel from "../conversation-lead-details-panel"
import { Threads } from "../../../types"

interface Props {
  isLoading: boolean
  threads: Threads
  filteredThreads: Threads
}

const ConversationsWithListAndThread = ({
  isLoading,
  threads,
  filteredThreads
}: Props) => {
  const { _id = "" } = useParams<{ _id: string }>()

  return (
    <>
      <div className="flex flex-1 overflow-hidden h-full">
        <ConversationsList
          filteredThreads={filteredThreads}
          isLoading={isLoading}
        />

        {_id ? (
          <div
            className={`bg-[#F8F8F8] flex flex-col overflow-y-auto min-w-full w-screen sm:w-full transition-transform sm:min-w-0 z-20 ${
              _id ? "-translate-x-full sm:transform-none" : "translate-x-0"
            }`}
          >
            <ConversationsThread threads={threads} />
          </div>
        ) : (
          <If
            condition={!isLoading}
            then={
              <div className="bg-[#F8F8F8] flex-col items-center justify-center w-full hidden md:flex">
                <p>Select a thread to view messages.</p>
              </div>
            }
          />
        )}
      </div>
      <ImagePreviewPanel />
      <ConversationLeadDetailsPanel />
    </>
  )
}

export default ConversationsWithListAndThread
